 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"agents~approve_commissions~approve_payouts~bets_and_commissions~change_password~dashboard~home~mycom~b6904e66":"agents~approve_commissions~approve_payouts~bets_and_commissions~change_password~dashboard~home~mycom~b6904e66","agents~approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~players~prog~5accbacd":"agents~approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~players~prog~5accbacd","agents":"agents","approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~progressive~settled~dbf7594d":"approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~progressive~settled~dbf7594d","approve_commissions":"approve_commissions","approve_payouts":"approve_payouts","bets_and_commissions~progressive":"bets_and_commissions~progressive","bets_and_commissions":"bets_and_commissions","progressive":"progressive","dashboard":"dashboard","mycommissions":"mycommissions","settledcommissions~settledpayouts":"settledcommissions~settledpayouts","settledcommissions":"settledcommissions","settledpayouts":"settledpayouts","token_movements":"token_movements","players":"players","change_password":"change_password","home~register~registernewformat~reset_password":"home~register~registernewformat~reset_password","home":"home","register":"register","registernewformat":"registernewformat","reset_password":"reset_password","referral_links":"referral_links","pagenotfound":"pagenotfound"}[chunkId]||chunkId) + "." + {"agents~approve_commissions~approve_payouts~bets_and_commissions~change_password~dashboard~home~mycom~b6904e66":"2a76b200","agents~approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~players~prog~5accbacd":"68858aa1","agents":"6d887dfd","approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~progressive~settled~dbf7594d":"0af8025a","approve_commissions":"4daed3fa","approve_payouts":"60114cc8","bets_and_commissions~progressive":"8d7f80a1","bets_and_commissions":"fd0b215d","progressive":"5a887617","dashboard":"d39c4b1c","mycommissions":"557e518c","settledcommissions~settledpayouts":"f5f405f0","settledcommissions":"26a3af18","settledpayouts":"14af2c81","token_movements":"70597222","players":"9f616341","change_password":"a0c806b7","home~register~registernewformat~reset_password":"7c7f72fd","home":"5eb04972","register":"10bd132a","registernewformat":"1a0d953a","reset_password":"a84bd696","referral_links":"b3cfaeca","pagenotfound":"d7610bc3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"agents~approve_commissions~approve_payouts~bets_and_commissions~change_password~dashboard~home~mycom~b6904e66":1,"agents~approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~players~prog~5accbacd":1,"agents":1,"approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~progressive~settled~dbf7594d":1,"approve_commissions":1,"approve_payouts":1,"bets_and_commissions~progressive":1,"progressive":1,"mycommissions":1,"settledcommissions~settledpayouts":1,"token_movements":1,"players":1,"change_password":1,"home~register~registernewformat~reset_password":1,"referral_links":1,"pagenotfound":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"agents~approve_commissions~approve_payouts~bets_and_commissions~change_password~dashboard~home~mycom~b6904e66":"agents~approve_commissions~approve_payouts~bets_and_commissions~change_password~dashboard~home~mycom~b6904e66","agents~approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~players~prog~5accbacd":"agents~approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~players~prog~5accbacd","agents":"agents","approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~progressive~settled~dbf7594d":"approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~progressive~settled~dbf7594d","approve_commissions":"approve_commissions","approve_payouts":"approve_payouts","bets_and_commissions~progressive":"bets_and_commissions~progressive","bets_and_commissions":"bets_and_commissions","progressive":"progressive","dashboard":"dashboard","mycommissions":"mycommissions","settledcommissions~settledpayouts":"settledcommissions~settledpayouts","settledcommissions":"settledcommissions","settledpayouts":"settledpayouts","token_movements":"token_movements","players":"players","change_password":"change_password","home~register~registernewformat~reset_password":"home~register~registernewformat~reset_password","home":"home","register":"register","registernewformat":"registernewformat","reset_password":"reset_password","referral_links":"referral_links","pagenotfound":"pagenotfound"}[chunkId]||chunkId) + "." + {"agents~approve_commissions~approve_payouts~bets_and_commissions~change_password~dashboard~home~mycom~b6904e66":"059165d0","agents~approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~players~prog~5accbacd":"718794fa","agents":"5cca6238","approve_commissions~approve_payouts~bets_and_commissions~dashboard~mycommissions~progressive~settled~dbf7594d":"2090ba31","approve_commissions":"34791a74","approve_payouts":"4eb0deb2","bets_and_commissions~progressive":"4eb0deb2","bets_and_commissions":"31d6cfe0","progressive":"cf6fe5fe","dashboard":"31d6cfe0","mycommissions":"7a3e73f2","settledcommissions~settledpayouts":"4eb0deb2","settledcommissions":"31d6cfe0","settledpayouts":"31d6cfe0","token_movements":"44b5acce","players":"4eb0deb2","change_password":"df9d9a7c","home~register~registernewformat~reset_password":"df9d9a7c","home":"31d6cfe0","register":"31d6cfe0","registernewformat":"31d6cfe0","reset_password":"31d6cfe0","referral_links":"7a3e73f2","pagenotfound":"f0222215"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
